import React from 'react';
import { ModalFooter, ModalFooterProps } from 'reactstrap';
import merge from 'classnames';

type Props = ModalFooterProps & {
  confirmation?: boolean;
};

export const ModalFooterProxy = ({ confirmation, ...props }: Props) => (
  <ModalFooter {...props} className={merge(props.className, { confirmation: confirmation })} />
);
